<template>
    <rkm-area
        :closed="closed"
        background-color="primary"
        title="SINAIS VITAIS"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.pressaoArterial"
                    @change.native="handlePressaoArterialChange"
                    label="Pressão arterial"
                    placeholder="000/000"
                    v-mask="'###/###'"
                    v-model="data.model.sinalVital.pressaoArterial"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            mmHg
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.frequenciaRespiratoria"
                    label="Frequência respiratória"
                    placeholder="000"
                    v-mask="'###'"
                    v-model="data.model.sinalVital.frequenciaRespiratoria"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            mpm
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.frequenciaCardiaca"
                    label="Frequência cardíaca"
                    placeholder="000"
                    v-mask="'###'"
                    v-model="data.model.sinalVital.frequenciaCardiaca"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            bpm
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.temperatura"
                    @change.native="handleTemperaturaChange"
                    label="Temperatura"
                    placeholder="00,0"
                    v-mask="'##.#'"
                    v-model="data.model.sinalVital.temperatura"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            °C
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.saturacaoO2"
                    label="Saturação de O2"
                    placeholder="000"
                    v-mask="'###'"
                    v-model="data.model.sinalVital.saturacaoO2"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            %
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxSinalVital
                    v-if="data && data.form && data.form.sinalVital"
                    :data="data.form.sinalVital"
                    title="Sinais vitais realizados na mesma data, durante o acolhimento."
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import BoxSinalVital from '@/components/ambulatorio/atendimento/components/historico/components/sinal-vital/Index'

export default {
    components: {
        BoxSinalVital,
    },
    computed: {
        validations() {
            return {
                pressaoArterial: {
                    min_max_without_mask: [6],
                    pressao_arterial: true,
                },
                frequenciaRespiratoria: {
                    min_value: 0,
                    max_value: 200,
                },
                frequenciaCardiaca: {max_value: 999},
                temperatura: {
                    min_value: 20,
                    max_value: 45,
                },
                saturacaoO2: {
                    min_value: 0,
                    max_value: 100,
                },
            }
        },
    },
    methods: {
        handlePressaoArterialChange(event) {
            if (!event.target.classList.contains('is-invalid')) {
                this.$emit('pressaoArterialChange', event.target.value)
            }
        },
        handleTemperaturaChange(event) {
            if (!event.target.classList.contains('is-invalid')) {
                this.$emit('temperaturaChange', event.target.value)
            }
        },
    },
    props: {
        closed: {type: Boolean, default: false},
        data: {type: Object, required: true},
    },
}
</script>